import {Component} from './component.interface';

export function bootstrapComponent(component: Component, entryElementSelector: string): void {
    const el: HTMLElement = document.querySelector(entryElementSelector) as HTMLElement;
    if (el === null) {
        throw new Error(`entry element selection ${entryElementSelector} is empty.`);
    }

    component.bootstrapped = true;
    component.injectDom(el);
    component.init();
}